/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * <p>
 * Copyright © 2019 Pearson Education, Inc.
 * All Rights Reserved.
 * <p>
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 *
 * This is the data class for holding partner attributes.
 *
 * @author urahish
 * 11/06/2019
 *
 */

import React from 'react';

/**
 * functional component for the checkbox
 * @param name - name of the input
 * @param checked - checked or not
 * @param onChange - onChange
 * @returns {*}
 */
const checkbox = ({name, checked, onChange, isDisabled = false }) => (
    <input type="checkbox" name={name} checked={checked} onChange={onChange} aria-label={name}  disabled={isDisabled} />
);

export default checkbox;
